
    import {defineComponent, computed, reactive} from "vue";
    import store from '../store/index'

    export default defineComponent({
        name: "board",
        setup() {

            const state = reactive({
                store: computed(() => store.state),
            })

            function isClickable(tile: any) {
                if (!state.store.playersTurn) return 'not-allowed'
                if (tile.length == 0) {
                    return 'pointer'
                }
                return 'default'
            }

            const playerAction = (i: number) => {
                store.dispatch('playerClick', i)
            }
            return {
                store: state.store,
                playerAction,
                isClickable
            }
        }
    })
